export default __webpack_public_path__ + "static/media/dark.490dd517.png";